import { Injectable, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MessageLogger } from './interfaces/message-logger.interface';
import { MESSAGE_LOGGING_CONFIG } from './interfaces/message-logging.config';

@Injectable()
export class MessageLoggingService extends MessageLogger {
  private readonly config = inject(MESSAGE_LOGGING_CONFIG, { optional: true });

  logMessage(message: string): void {
    const config = this.config;

    // Application Insights (via app-provided callback)
    if (config?.logToAppInsights) {
      try {
        config.logToAppInsights(new Error(message));
      } catch {
        // Intentionally empty - don't let logging failures break handler
      }
    }

    // Sentry
    if (config?.sentryEnabled) {
      try {
        Sentry.captureMessage(message, 'error');
      } catch {
        // Intentionally empty - don't let Sentry failures break handler
      }
    }
  }
}
